var exports = {
  "kL": "AudioPlayer.module__container___RUNIdE",
  "Md": "AudioPlayer.module__fileName___RUNIdE",
  "NE": "AudioPlayer.module__progressSection___RUNIdE",
  "hr": "AudioPlayer.module__progressBar___RUNIdE",
  "Ey": "AudioPlayer.module__timeDisplay___RUNIdE",
  "ne": "AudioPlayer.module__controls___RUNIdE",
  "gm": "AudioPlayer.module__mainControls___RUNIdE",
  "Rr": "AudioPlayer.module__playButton___RUNIdE",
  "$3": "AudioPlayer.module__seekButton___RUNIdE",
  "f6": "AudioPlayer.module__secondaryControls___RUNIdE",
  "Wq": "AudioPlayer.module__volumeControl___RUNIdE",
  "Sn": "AudioPlayer.module__playbackRate___RUNIdE",
  "Hw": "AudioPlayer.module__mobile___RUNIdE",
};

module.exports = exports;
